import {
  Button,
  createSortableColumn,
  DataTable,
  type TanstackReactTable,
} from "@devhop/ui";
import { Eye } from "lucide-react";
import type { OTSummaryByMonthItem } from "@/modules/hr/overtime/domain/types";

type OTSummaryTableProps = {
  data: OTSummaryByMonthItem[];
  isLoading?: boolean;
  sortBy?: string;
  sortOrder?: "asc" | "desc";
  onSortingChange: (id: string, desc: boolean) => void;
  onViewDetail?: (row: OTSummaryByMonthItem) => void;
};

export function OTSummaryTable({
  data,
  isLoading,
  sortBy,
  sortOrder,
  onSortingChange,
  onViewDetail,
}: OTSummaryTableProps) {
  const columns: TanstackReactTable.ColumnDef<OTSummaryByMonthItem>[] = [
    createSortableColumn<OTSummaryByMonthItem>("employeeName", "ພະນັກງານ", {
      size: 200,
      cell: ({ row }) => (
        <div>
          <div className="font-medium">{row.original.employeeName}</div>
          <div className="text-muted-foreground text-xs">{row.original.employeeEmail}</div>
        </div>
      ),
    }),
    createSortableColumn<OTSummaryByMonthItem>("departmentName", "ແຜ່ນການ / ຕໍາແໜ່ງ", {
      size: 200,
      cell: ({ row }) => (
        <span className="text-muted-foreground text-sm">
          {row.original.departmentName ?? "—"}
          {row.original.positionTitle != null && (
            <span className="ml-1"> / {row.original.positionTitle}</span>
          )}
        </span>
      ),
    }),
    createSortableColumn<OTSummaryByMonthItem>("totalHours", "ຊົ່ວໂມງ OT ລວມ", {
      size: 140,
      cell: ({ row }) => (
        <span className="font-medium tabular-nums">
          {row.original.totalHours.toFixed(1)} ຊມ.
        </span>
      ),
    }),
    ...(onViewDetail
      ? [
          {
            id: "actions",
            header: "",
            cell: ({ row }: { row: { original: OTSummaryByMonthItem } }) => (
              <Button
                size="sm"
                variant="ghost"
                onClick={() => onViewDetail(row.original)}
                aria-label="ເບິ່ງລາຍລະອຽດ"
              >
                <Eye className="h-4 w-4" />
                ເບິ່ງລາຍລະອຽດ
              </Button>
            ),
            size: 120,
          } as TanstackReactTable.ColumnDef<OTSummaryByMonthItem>,
        ]
      : []),
  ];

  return (
    <DataTable<OTSummaryByMonthItem, unknown>
          noDataMessage="ບໍ່ພົບຂໍ້ມູນ OT ໃນເດືອນທີ່ເລືອກ."
          isLoading={isLoading}
          columns={columns}
          data={data}
          offset={0}
          limit={data.length}
          totalCount={data.length}
          onPaginationChange={() => {}}
          sortBy={sortBy}
          sortOrder={sortOrder}
          onSortingChange={(sorting) => {
            if (sorting[0]?.id === "") return;
            onSortingChange(sorting[0]?.id ?? "totalHours", !!sorting[0]?.desc);
          }}
        />
  );
}
